import BillingsTaxiTaxiUpdateStatusRequest, {
  BillingsTaxiTaxiUpdateStatusRequestBody,
} from "./billings-taxi-taxi-update-status.request";

const createBody = (
  request: BillingsTaxiTaxiUpdateStatusRequest,
): BillingsTaxiTaxiUpdateStatusRequestBody => {
  return {
    status: request.status,
    comment: request.comment,
  };
};

const billingsTaxiTaxiUpdateStatusRequestFactory = {
  createBody,
};

export default billingsTaxiTaxiUpdateStatusRequestFactory;
